import React from 'react'

const RestoreBrushIcon = ({color = 'currentColor', bgColor = 'white', borderColor = '#D8DBDE', width = 32, height = 32, showBadge = false, ...rest}) => (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <circle cx="16" cy="16" r="15.5" fill={bgColor} stroke={borderColor} />
        <path d="M16.75 10.75H15.25V15.25H10.75V16.75H15.25V21.25H16.75V16.75H21.25V15.25H16.75V10.75Z" fill={color} />
        {showBadge && (
            <g>
                <circle cx="26" cy="6" r="6" fill="#007BFF" />
                <path d="M23.5 6L25.5 8L28.5 4.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
        )}
    </svg>
)

export default RestoreBrushIcon
